/**
 * WS keepalive Worker 工厂 — 使用 inline Blob，避免 Vite module worker 在 H5/真机打包异常
 * （「Class extends value undefined is not a constructor or null」）
 */

const KEEPALIVE_WORKER_SCRIPT = `
var timer = null;
self.onmessage = function(ev) {
  var data = ev.data;
  if (data.cmd === 'stop') {
    if (timer) clearInterval(timer);
    timer = null;
    return;
  }
  if (data.cmd === 'start') {
    if (timer) clearInterval(timer);
    var ms = Math.max(1000, data.intervalMs || 4000);
    timer = setInterval(function() {
      self.postMessage({ type: 'tick' });
    }, ms);
  }
};
`

/** 创建 classic Worker；失败时返回 null，由调用方 fallback 到 setInterval */
export function createWsKeepaliveWorker(onTick: () => void): Worker | null {
  if (typeof Worker === 'undefined' || typeof Blob === 'undefined') {
    return null
  }
  try {
    const blob = new Blob([KEEPALIVE_WORKER_SCRIPT], { type: 'application/javascript' })
    const url = URL.createObjectURL(blob)
    const worker = new Worker(url)
    worker.onmessage = () => onTick()
    worker.onerror = () => {
      worker.terminate()
      URL.revokeObjectURL(url)
    }
    return worker
  } catch {
    return null
  }
}
